export default "__VITE_ASSET__DI$XSkdP__"